// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LumiFloat from "lumi-rescript/lib/es6/src/LumiFloat.res.js";
import * as V2f$Linear from "./V2f.res.js";
import * as M33f$Linear from "./M33f.res.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";

let SimpleTransform = {};

function toM33f(param) {
  return [
    param[0],
    param[1],
    [
      0,
      0,
      1
    ]
  ];
}

function fromM33f(param) {
  return [
    param[0],
    param[1]
  ];
}

let identity = fromM33f(M33f$Linear.identity);

function apply(v, m) {
  return V2f$Linear.asV3f(v, v => M33f$Linear.Mult.v3f(toM33f(m), v));
}

function transformLine(m, param) {
  return {
    from: apply(param.from, m),
    to: apply(param.to, m)
  };
}

function rotation(angle) {
  return [
    [
      Math.cos(angle),
      -1 * Math.sin(angle),
      0
    ],
    [
      Math.sin(angle),
      Math.cos(angle),
      0
    ]
  ];
}

function compose(m1, m2) {
  return fromM33f(M33f$Linear.Mult.m33f(toM33f(m1), toM33f(m2)));
}

function scale(param) {
  return [
    [
      param[0],
      0,
      0
    ],
    [
      0,
      param[1],
      0
    ]
  ];
}

let mirror = [
  [
    -1,
    0,
    0
  ],
  [
    0,
    1,
    0
  ]
];

function addTranslation(param, param$1) {
  let match = param[1];
  let match$1 = param[0];
  return [
    [
      match$1[0],
      match$1[1],
      match$1[2] + param$1[0]
    ],
    [
      match[0],
      match[1],
      match[2] + param$1[1]
    ]
  ];
}

function translation(param) {
  return [
    [
      1,
      0,
      param[0]
    ],
    [
      0,
      1,
      param[1]
    ]
  ];
}

function rotationAround(angle, point) {
  return compose(compose(translation(point), rotation(angle)), translation(V2f$Linear.scale(point, -1)));
}

function mirrorAround(point) {
  return compose(compose(translation(point), mirror), translation(V2f$Linear.scale(point, -1)));
}

function approxEqual(m1, m2) {
  let match = m2[1];
  let y2 = match[2];
  let d2 = match[1];
  let c2 = match[0];
  let match$1 = m2[0];
  let x2 = match$1[2];
  let b2 = match$1[1];
  let a2 = match$1[0];
  let match$2 = m1[1];
  let y1 = match$2[2];
  let d1 = match$2[1];
  let c1 = match$2[0];
  let match$3 = m1[0];
  let x1 = match$3[2];
  let b1 = match$3[1];
  let a1 = match$3[0];
  let magnitude = Math.max(...[
    a1,
    b1,
    c1,
    d1,
    x1,
    y1,
    a2,
    b2,
    c2,
    d2,
    x2,
    y2
  ].map(prim => Math.abs(prim)));
  let epsilon = 1e-10 * magnitude;
  if (LumiFloat.approxEqual(a1, a2, epsilon) && LumiFloat.approxEqual(b1, b2, epsilon) && LumiFloat.approxEqual(c1, c2, epsilon) && LumiFloat.approxEqual(d1, d2, epsilon) && LumiFloat.approxEqual(x1, x2, epsilon)) {
    return LumiFloat.approxEqual(y1, y2, epsilon);
  } else {
    return false;
  }
}

function toSimpleTransform(param) {
  let match = param[1];
  let d = match[1];
  let c = match[0];
  let match$1 = param[0];
  let b = match$1[1];
  let a = match$1[0];
  let mirror = a * d - b * c < 0.0;
  return {
    scale: [
      V2f$Linear.length([
        a,
        c
      ]),
      V2f$Linear.length([
        b,
        d
      ])
    ],
    mirror: mirror,
    rotate: Math.atan2(c, d) * (
      mirror ? -1 : 1
    ),
    translate: [
      match$1[2],
      match[2]
    ]
  };
}

function fromSimpleTransform(simpleTransform) {
  let m = simpleTransform.mirror ? mirror : identity;
  let s = scale(simpleTransform.scale);
  let r = rotation(simpleTransform.rotate);
  let t = translation(simpleTransform.translate);
  return compose(compose(compose(t, r), s), m);
}

function isSimpleTransform(m23) {
  let decomposed = toSimpleTransform(m23);
  let reconstructed = fromSimpleTransform(decomposed);
  if (Primitive_object.equal(m23, reconstructed)) {
    return decomposed;
  }
}

let M23f = {
  toM33f: toM33f,
  fromM33f: fromM33f,
  identity: identity,
  apply: apply,
  transformLine: transformLine,
  rotation: rotation,
  compose: compose,
  scale: scale,
  mirror: mirror,
  addTranslation: addTranslation,
  translation: translation,
  rotationAround: rotationAround,
  mirrorAround: mirrorAround,
  approxEqual: approxEqual,
  toSimpleTransform: toSimpleTransform,
  fromSimpleTransform: fromSimpleTransform,
  isSimpleTransform: isSimpleTransform
};

function rotation$1(angle) {
  return toM33f(rotation(angle));
}

function scale$1(v) {
  return toM33f(scale(v));
}

function translation$1(v) {
  return toM33f(translation(v));
}

function addTranslation$1(m, v) {
  return toM33f(addTranslation(fromM33f(m), v));
}

function rotationAround$1(angle, point) {
  return toM33f(rotationAround(angle, point));
}

let M33f = {
  toM23f: fromM33f,
  fromM23f: toM33f,
  rotation: rotation$1,
  scale: scale$1,
  translation: translation$1,
  addTranslation: addTranslation$1,
  rotationAround: rotationAround$1
};

export {
  SimpleTransform,
  M23f,
  M33f,
}
/* identity Not a pure module */
